import { render, staticRenderFns } from "./SupplierVerificationSourceBadge.vue?vue&type=template&id=52ef05fe&"
import script from "./SupplierVerificationSourceBadge.vue?vue&type=script&lang=js&"
export * from "./SupplierVerificationSourceBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports